<template>
  <section class="section-services section container" id="services">
    <div class="section-services__header">
      <div>
        <p class="section__subtitle section-services__subtitle">
            {{ $t('lnd.serv.title') }}
        </p>
        <h2 class="section__title section-services__title">
            {{ $t('lnd.serv.subtitle') }}
        </h2>
      </div>

      <div class="section-services__nav">
        <button class="section-services__nav-prev swiper-slide-nav swiper-slide-nav-prev" type="button">
          <span class="visually-hidden">Prev slide</span>
        </button>
        <button class="section-services__nav-next swiper-slide-nav swiper-slide-nav-next" type="button">
          <span class="visually-hidden">Next slide</span>
        </button>
      </div>
    </div>

    <div class="swiper section-services__slider">
      <div class="swiper-wrapper section-services__cards">
         <div class="swiper-slide">
          <article class="section-services__card section-services__card_type_mobile">
            <h3 class="section-services__card-title">
              {{ $t('lnd.serv.s1.title') }}
            </h3>
            <p class="section-services__card-text">
              <b>{{ $t('lnd.serv.s1.subtitle') }}</b>
            </p>
            <p class="section-services__card-text">
              {{ $t('lnd.serv.s1.text') }}
            </p>
            <a
              href="https://dexmobile.io"
              target="_blank"
              class="button section-services__card-button"
            >
              <span>
                {{ $t('Learn More') }}
              </span>
            </a>
          </article>
        </div>

        <div class="swiper-slide">
          <article class="section-services__card section-services__card_type_safe">
            <h3 class="section-services__card-title">
              {{ $t('lnd.serv.s2.title') }}
            </h3>
            <p class="section-services__card-text">
              <b>{{ $t('lnd.serv.s2.subtitle') }}</b>
            </p>
            <p class="section-services__card-text">
              {{ $t('lnd.serv.s2.text') }}
            </p>
            <a
              href="https://dexsafe.io"
              target="_blank"
              class="button section-services__card-button"
            >
              <span>
                {{ $t('Learn More') }}
              </span>
            </a>
          </article>
        </div>

        <div class="swiper-slide">
          <article class="section-services__card section-services__card_type_cloud">
            <h3 class="section-services__card-title">
              {{ $t('lnd.serv.s3.title') }}
            </h3>
            <p class="section-services__card-text">
              <b>{{ $t('lnd.serv.s3.subtitle') }}</b>
            </p>
            <p class="section-services__card-text">
              {{ $t('lnd.serv.s3.text') }}
            </p>
            <a
              href="https://dexcloud.one"
              target="_blank"
              class="button section-services__card-button"
            >
              <span>
                {{ $t('Learn More') }}
              </span>
            </a>
          </article>
        </div>


        <div class="swiper-slide">
          <article class="section-services__card section-services__card_type_point">
            <h3 class="section-services__card-title">
              {{ $t('lnd.serv.s4.title') }}
            </h3>
            <p class="section-services__card-text">
              <b>{{ $t('lnd.serv.s4.subtitle') }}</b>
              <b></b>
            </p>
            <p class="section-services__card-text">
              {{ $t('lnd.serv.s4.text') }}
            </p>
            <a
              href="https://dexpoint.io"
              target="_blank"
              class="button section-services__card-button"
            >
              <span>
                {{ $t('Learn More') }}
              </span>
            </a>
          </article>
        </div>

        <div class="swiper-slide">
          <article class="section-services__card section-services__card_type_cards ">
            <h3 class="section-services__card-title">
              {{ $t('lnd.serv.s5.title') }}
            </h3>
            <p class="section-services__card-text">
              <b>{{ $t('lnd.serv.s5.subtitle') }}</b>
            </p>
            <p class="section-services__card-text">
              {{ $t('lnd.serv.s5.text') }}
            </p>
            <a
              href="https://t.me/DexCardsBot"
              target="_blank"
              class="button section-services__card-button"
            >
              <span>
                {{ $t('Learn More') }}
              </span>
            </a>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper"
import { Navigation } from 'swiper/modules'

export default {
  mounted() {
    new Swiper(".section-services__slider", {
      modules: [Navigation],
      slidesPerView: 1.15,
      spaceBetween: 16,
      centeredSlides: true,
      navigation: {
        nextEl: ".section-services__nav-next",
        prevEl: ".section-services__nav-prev",
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 16,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 32,
          centeredSlides: false,
        }
      }
    });
  }
}
</script>
